<style>
  .Warning {
    background-color: #ff9595 !important;
  }

  .TdTitle {
    background: #17b88b;
    color: white;
    font-weight: bold;
  }

  .AfterTr {
    background-color: #489b39;
    color: white;
  }

  .BeforeTr {
    background-color: #9b3939;
    color: white;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات گواهی نامه</h5>

    <div>

      <app-DataEntityDeviceInfo [inner_calibration_id]="Calibration_Device_Id"
        (outter_Calibration_Device)="Set_CalibrationDeviceInfo_click($event)">

      </app-DataEntityDeviceInfo>

      <br/>

      <form>
        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> کد دستگاه (Sensor) </label>
            <input [(ngModel)]="Code1_txt" name="Code1_txt" placeholder="اینجا تایپ کنید ..." type="text"
              class="form-control">
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> سریال دستگاه (Sensor) </label>
            <input [(ngModel)]="Serial1_txt" name="Serial1_txt" placeholder="اینجا تایپ کنید ..." type="text"
              class="form-control">
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Certificate Code </label>
            <input value="{{CertificateCode}}" disabled type="text" class="form-control">
          </div>

          <div class="form-group col-md-4">
            <app-DataEntityLabAddress [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Lab_Address]="Calibration_Device.labAdderss"
              (outter_selected_Lab_Address)="Set_LabAddress_click($event)">

            </app-DataEntityLabAddress>
          </div>

          <div class="form-group col-md-4">
            <app-DataEntityLinearity [inner_Calibration_Device_Id]="Calibration_Device_Id"
              [inner_Calibration_Display]="Calibration_Device.display_linearity">

            </app-DataEntityLinearity>
          </div>

        </div>
      </form>

      <br />
      <hr />
      <br />

      <app-DataEntityCertificateNote [inner_Calibration_Device_Id]="Calibration_Device_Id">

      </app-DataEntityCertificateNote>

      <br />
      <hr />
      <br />

      <app-AddressLetterCertificate [inner_Calibration_Detail_Id]="Calibration_Device_Id">

      </app-AddressLetterCertificate>

      <br />
      <hr />
      <br />

      <form>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Reference Value </label>
            <select class="custom-select" (change)="OnUserSetUnit(2,templateUnit)" [(ngModel)]="unit_reference" name="unit_reference">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Sample's Indication </label>
            <select class="custom-select" [(ngModel)]="unit_indication" (change)="OnUserSetUnit(1,templateUnit)" name="unit_indication">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Correction </label>
            <select class="custom-select" (change)="OnUserSetUnit(3,templateUnit)" [(ngModel)]="unit_correction" name="unit_correction">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Correction from Line Equation </label>
            <select class="custom-select" (change)="OnUserSetUnit(4,templateUnit)"  [(ngModel)]="unit_correction_eqution" name="unit_correction_eqution">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Uncertainty </label>
            <select class="custom-select" (change)="OnUserSetUnit(5,templateUnit)"  [(ngModel)]="unit_uncertainy" name="unit_uncertainy">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> واحد Working </label>
            <select class="custom-select" [(ngModel)]="unit_working" (change)="OnUserSetUnit(6,templateUnit)"  name="unit_working">
              <option value="">انتخاب کنید</option>
              <option *ngFor="let item of DataList_Unit" [value]="item.title">
                <div innerHTML="{{item.title}}"></div>
              </option>
            </select>

          </div>

        </div>
      </form>

      <br />
      <hr />
      <br />


      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MANUFACTURE </label>
            <input [(ngModel)]="Manufacture_txt" name="Manufacture_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> TYPE </label>
            <select class="custom-select" [(ngModel)]="Type_txt" name="Type_txt">
              <option value="">انتخاب کنید</option>
              <option value="DIGITAL">Digital</option>
              <option value="ANALOG">Analog</option>
              <option value="Liquid in glass / environmental">Liquid in glass / environmental</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MODEL </label>
            <input [(ngModel)]="Model_txt" name="Model_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>


        </div>
      </form>

      <form>
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MANUFACTURE (Sensor1) </label>
            <input [(ngModel)]="Manufacture1_txt" name="Manufacture1_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> TYPE (Sensor1) </label>

            <select class="custom-select" [(ngModel)]="Type1_txt" name="Type1_txt">
              <option value="">انتخاب کنید</option>
              <option value="Type K">Type K</option>
              <option value="Type T">Type J</option>
              <option value="Type T">Type S</option>
              <option value="Type T">Type T</option>
              <option value="PT 100">PT 100</option>
              <option value="PT 100 4wire">PT 100 4wire</option>
              <option value="PT 100 3wire">PT 100 3wire</option>
              <option value="PT 100 2wire">PT 100 2wire</option>
              <option value="PT 1000">PT 1000</option>
            </select>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Model (Sensor 1) </label>
            <input [(ngModel)]="Model2_txt" name="Model2_txt" type="text" class="form-control"
              placeholder="اینجا تایپ کنید ...">
          </div>


        </div>
      </form>

      <form>
        <div class="row">


          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> MODEL (Sensor 2) </label>
            <select class="custom-select" [(ngModel)]="Model1_txt" name="Model1_txt">
              <option value="">انتخاب کنید</option>
              <option value="Max-Min">Max-Min</option>
              <option value="In-Out">In-Out</option>
              <option value="Room-Fridge">Room-Fridge</option>
            </select>
          </div>


        </div>
      </form>

      <br />
      <hr />
      <br />

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> بارگذاری فایل پیوست : </label>
            <input type="file" #file_pdf>
          </div>
          <div class="form-group col-md-6">
            <img *ngIf="Procssing_Import2" src="assets/Loading.gif" style="width: 25px;" />
            <button *ngIf="!Procssing_Import2" type="button" class="btn btn-info"
              (click)="upload_file_pdf(file_pdf.files)"> بارگذاری فایل پیوست <i class="fa fa-upload"></i></button>
          </div>
        </div>
      </form>

      <br />
      <hr />
      <br />

      <form [formGroup]="MainFormDataEntity">

        <div class="row">
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © before </label>
            <input formControlName="Temperature_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_before().valid && get_Form_Temperature_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © before را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Temperature of Air © after </label>
            <input formControlName="Temperature_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Temperature_Air_after().valid && get_Form_Temperature_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Tmperature of Air © after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) before </label>
            <input formControlName="Humidity_Air_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_before().valid && get_Form_Humidity_Air_before().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Humidity of Air (%rH) after </label>
            <input formControlName="Humidity_Air_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Humidity_Air_after().valid && get_Form_Humidity_Air_after().touched"
              class="form-text text-muted MyErrorRedColor">Humidity of Air (%rH) after را وارد نمائید.</small>
          </div>


        </div>

        <div class="row">

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) before </label>
            <input formControlName="Pressure_before" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_before().valid && get_Form_Pressure_before().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) before را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-3">
            <label for="exampleInputEmail1"> Ambient Pressure (hPa) after </label>
            <input formControlName="Pressure_after" type="number" class="form-control"
              placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Pressure_after().valid && get_Form_Pressure_after().touched"
              class="form-text text-muted MyErrorRedColor">Ambient Pressure (hPa) after را وارد نمائید.</small>
          </div>

          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> نحوه نمایش Working </label>
            <select class="custom-select" formControlName="working_type">
              <option value="1">پیوسته</option>
              <option value="2">ناپیوسته</option>
            </select>
          </div>

        </div>


      </form>

      <br />
      <hr />
      <br />

      <h5 class="card-title">Working</h5>

      <form [formGroup]="ResolutionFormDataEntity_Working" (submit)="Add_Resolution_Working()">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> Value </label>
            <input formControlName="value" type="text" class="form-control EnglishClm"
              placeholder="اینجا تایپ کنید ...">
          </div>
        </div>
        <button type="submit" [disabled]="!ResolutionFormDataEntity_Working.valid" class="btn btn-success"
          style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      </form>

      <br />
      <br />

      <div class="table-responsive" *ngIf="DataList_Resolution_Working.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39409b; color: white;">
            <tr>
              <th>#</th>
              <th>Value</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Resolution_Working">
              <td>{{DataList_Resolution_Working.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.value}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                      <a style="cursor: pointer;" class="dropdown-item"
                        (click)="Delete_Resolution_Working(DataList_Resolution_Working.indexOf(item))"><i
                          class="fa fa-remove"></i> حذف
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>


        </table>
      </div>

      <br />
      <hr />
      <br />

    </div>

    <div class="card-body">
      <div class="tab nav-border" style="position: relative;">

        <div class="d-block d-md-flex justify-content-between" *ngIf="Model1_txt">
          <div class="d-block d-md-flex nav-tabs-custom">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active show" id="months-tab" data-toggle="tab" href="#form1" role="tab"
                  aria-controls="months" aria-selected="true">

                  <span *ngIf="Model1_txt">{{Model1_txt.split('-')[0]}}</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link  show" *ngIf="Model1_txt" id="months-tab" data-toggle="tab" href="#form2" role="tab"
                  aria-controls="months" aria-selected="true">{{Model1_txt.split('-')[1]}}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="tab-content" id="myTabContent">

          <div class="tab-pane fade active show" id="form1" role="tabpanel" aria-labelledby="months-tab">
            <div class="row mb-30">

              <div class="col-md-12 mb-30" style="margin-top: 100px;">

                <form>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="exampleInputEmail1"> بارگذاری فایل : </label>
                      <input type="file" #file_excel>
                    </div>
                    <div class="form-group col-md-6">
                      <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
                      <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
                        (click)="upload_file_excel(file_excel.files,1)"> بارگذاری فایل <i
                          class="fa fa-upload"></i></button>
                    </div>
                  </div>
                </form>

                <br />
                <hr />
                <br />

                <h5 *ngIf="Model1_txt" class="card-title">Range / Resolution</h5>
                <h5 *ngIf="!Model1_txt" class="card-title">Range / Resolution of indicator</h5>

                <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution(1)">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for="exampleInputEmail1"> Min Rage </label>
                      <input formControlName="range_min" type="text" class="form-control EnglishClm"
                        placeholder="اینجا تایپ کنید ...">
                    </div>

                    <div class="form-group col-md-4">
                      <label for="exampleInputEmail1"> Max Rage </label>
                      <input formControlName="range_max" type="text" class="form-control EnglishClm"
                        placeholder="اینجا تایپ کنید ...">
                    </div>

                    <div class="form-group col-md-4">
                      <label for="exampleInputEmail1"> SCALE DIVISION </label>
                      <input formControlName="scale" type="text" class="form-control EnglishClm"
                        placeholder="اینجا تایپ کنید ...">
                    </div>
                  </div>
                  <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
                    style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
                </form>

                <div class="table-responsive" *ngIf="DataList_Resolution.length>0">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">
                    <thead style="background-color: #39409b; color: white;">
                      <tr>
                        <th>#</th>
                        <th>Min Range</th>
                        <th>Max Range</th>
                        <th>SCALE DIVISION</th>
                        <th>امکانات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of DataList_Resolution">
                        <td>{{DataList_Resolution.indexOf(item)+1}}</td>
                        <td class="EnglishClm">{{item.range_min}}</td>
                        <td class="EnglishClm">{{item.range_max}}</td>
                        <td class="EnglishClm">{{item.scale}}</td>
                        <td>
                          <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                            <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                امکانات
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                <a style="cursor: pointer;" class="dropdown-item"
                                  (click)="Delete_Resolution(DataList_Resolution.indexOf(item),1)"><i
                                    class="fa fa-remove"></i> حذف
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>


                  </table>
                </div>

                <br />
                <br />

                <div *ngIf="!Model1_txt">

                  <h5 class="card-title">Range / Resolution of Sensor</h5>

                  <form [formGroup]="ResolutionFormDataEntity_Thermometer" (submit)="Add_Resolution_Thermometer(1)">
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label for="exampleInputEmail1"> Min Rage </label>
                        <input formControlName="range_min" type="text" class="form-control EnglishClm"
                          placeholder="اینجا تایپ کنید ...">
                      </div>

                      <div class="form-group col-md-6">
                        <label for="exampleInputEmail1"> Max Rage </label>
                        <input formControlName="range_max" type="text" class="form-control EnglishClm"
                          placeholder="اینجا تایپ کنید ...">
                      </div>

                      <div class="form-group col-md-4" style="display:none;">
                        <label for="exampleInputEmail1"> SCALE DIVISION </label>
                        <input formControlName="scale" type="text" class="form-control EnglishClm"
                          placeholder="اینجا تایپ کنید ...">
                      </div>
                    </div>
                    <button type="submit" [disabled]="!ResolutionFormDataEntity_Thermometer.valid"
                      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات
                    </button>
                  </form>

                  <div class="table-responsive" *ngIf="DataList_Resolution_Thermometer.length>0">
                    <table class="mb-0 table table-bordered table-3 text-center table-striped">
                      <thead style="background-color: #39409b; color: white;">
                        <tr>
                          <th>#</th>
                          <th>Min Range</th>
                          <th>Max Range</th>
                          <th>امکانات</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of DataList_Resolution_Thermometer">
                          <td>{{DataList_Resolution.indexOf(item)+1}}</td>
                          <td class="EnglishClm">{{item.range_min}}</td>
                          <td class="EnglishClm">{{item.range_max}}</td>
                          <td>
                            <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                              <div class="btn-group" role="group">
                                <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  امکانات
                                </button>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                  <a style="cursor: pointer;" class="dropdown-item"
                                    (click)="Delete_Resolution_Thermometer(DataList_Resolution_Thermometer.indexOf(item),1)"><i
                                      class="fa fa-remove"></i> حذف
                                  </a>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>


                    </table>
                  </div>

                  <br />
                  <br />

                </div>


                <div class="table-responsive" *ngIf="Nominal_Value_List.length>0">
                  <table class="mb-0 table table-bordered table-3 text-center table-striped">

                    <ng-container *ngFor="let item of Nominal_Value_List">



                      <tr>
                        <td colspan="8">

                          <table class="mb-0 table table-bordered table-3 text-center table-striped">

                            <thead [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">
                              <tr>
                                <th>#</th>
                                <th>Reference Value</th>
                                <th>Sample's Indication</th>
                                <th>Correction</th>
                                <th>Uncertainty</th>
                                <th>Converge Factor</th>
                                <th>امکانات</th>
                              </tr>
                            </thead>

                            <tbody>
                              <ng-container>

                                <tr [ngClass]="{'Warning': item.error>MPE_RND && item.sd>item.mpe_rnd }">

                                  <td>{{Nominal_Value_List.indexOf(item)+1}}</td>
                                  <td>{{item.reference}}</td>
                                  <td>
                                    <span *ngIf="item.before==false">{{item.indication}}</span>
                                    <input *ngIf="item.before==true" type="text" [(ngModel)]="item.indication" />
                                  </td>
                                  <td>{{item.correction}}</td>
                                  <td>{{item.uncertainty}}</td>
                                  <td>{{item.converage}}</td>
                                  <td>
                                    <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                                      <div class="btn-group" role="group">
                                        <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                          امکانات
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                          <a style="cursor: pointer;" *ngIf="item.before==false"
                                            (click)="Add_Before(Nominal_Value_List.indexOf(item),1)"
                                            class="dropdown-item">
                                            <i class="fa fa-arrow-circle-down"></i> کپی به عنوان Before
                                          </a>

                                          <a style="cursor: pointer;" *ngIf="item.before==true"
                                            (click)="Delete_Before(Nominal_Value_List.indexOf(item),1)"
                                            class="dropdown-item">
                                            <i class="fa fa-remove"></i> حذف Before
                                          </a>

                                        </div>
                                      </div>
                                    </div>

                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>

                          </table>

                        </td>
                      </tr>

                    </ng-container>

                  </table>
                </div>

              </div>

            </div>

          </div>

          <div class="tab-pane fade show" id="form2" role="tabpanel" aria-labelledby="months-tab">

            <div class="col-md-12 mb-30" style="margin-top: 100px;">

              <form>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="exampleInputEmail1"> بارگذاری فایل : </label>
                    <input type="file" #file_excel1>
                  </div>
                  <div class="form-group col-md-6">
                    <img *ngIf="Procssing_Import" src="assets/Loading.gif" style="width: 25px;" />
                    <button *ngIf="!Procssing_Import" type="button" class="btn btn-warning"
                      (click)="upload_file_excel(file_excel1.files,2)"> بارگذاری فایل <i
                        class="fa fa-upload"></i></button>
                  </div>
                </div>
              </form>

              <br />
              <hr />
              <br />

              <h5 class="card-title">Range / Resolution</h5>

              <form [formGroup]="ResolutionFormDataEntity" (submit)="Add_Resolution(2)">
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="exampleInputEmail1"> Min Rage </label>
                    <input formControlName="range_min" type="text" class="form-control EnglishClm"
                      placeholder="اینجا تایپ کنید ...">
                  </div>

                  <div class="form-group col-md-4">
                    <label for="exampleInputEmail1"> Max Rage </label>
                    <input formControlName="range_max" type="text" class="form-control EnglishClm"
                      placeholder="اینجا تایپ کنید ...">
                  </div>

                  <div class="form-group col-md-4">
                    <label for="exampleInputEmail1"> SCALE DIVISION </label>
                    <input formControlName="scale" type="text" class="form-control EnglishClm"
                      placeholder="اینجا تایپ کنید ...">
                  </div>
                </div>
                <button type="submit" [disabled]="!ResolutionFormDataEntity.valid" class="btn btn-success"
                  style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
              </form>


              <div class="table-responsive" *ngIf="DataList_Resolution_01.length>0">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #39409b; color: white;">
                    <tr>
                      <th>#</th>
                      <th>Min Range</th>
                      <th>Max Range</th>
                      <th>SCALE DIVISION</th>
                      <th>امکانات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of DataList_Resolution_01">
                      <td>{{DataList_Resolution_01.indexOf(item)+1}}</td>
                      <td class="EnglishClm">{{item.range_min}}</td>
                      <td class="EnglishClm">{{item.range_max}}</td>
                      <td class="EnglishClm">{{item.scale}}</td>
                      <td>
                        <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                          <div class="btn-group" role="group">
                            <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              امکانات
                            </button>
                            <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                              <a style="cursor: pointer;" class="dropdown-item"
                                (click)="Delete_Resolution(DataList_Resolution_01.indexOf(item),2)"><i
                                  class="fa fa-remove"></i> حذف
                              </a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>


                </table>
              </div>

              <div class="table-responsive" *ngIf="Nominal_Value_List_01.length>0">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">

                  <ng-container *ngFor="let item of Nominal_Value_List_01">



                    <tr>
                      <td colspan="8">

                        <table class="mb-0 table table-bordered table-3 text-center table-striped">

                          <thead [ngClass]="{'BeforeTr': item.before==true,'AfterTr': item.before==false }">
                            <tr>
                              <th>#</th>
                              <th>Reference Value</th>
                              <th>Sample's Indication</th>
                              <th>Correction</th>
                              <th>Uncertainty</th>
                              <th>Converge Factor</th>
                              <th>امکانات</th>
                            </tr>
                          </thead>

                          <tbody>
                            <ng-container>

                              <tr [ngClass]="{'Warning': item.error>MPE_RND && item.sd>item.mpe_rnd }">

                                <td>{{Nominal_Value_List_01.indexOf(item)+1}}</td>
                                <td>{{item.reference}}</td>
                                <td>
                                  <span *ngIf="item.before==false">{{item.indication}}</span>
                                  <input *ngIf="item.before==true" type="text" [(ngModel)]="item.indication" />
                                </td>
                                <td>{{item.correction}}</td>
                                <td>{{item.uncertainty}}</td>
                                <td>{{item.converage}}</td>
                                <td>
                                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                                    <div class="btn-group" role="group">
                                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        امکانات
                                      </button>
                                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                                        <a style="cursor: pointer;" *ngIf="item.before==false"
                                          (click)="Add_Before(Nominal_Value_List_01.indexOf(item),2)"
                                          class="dropdown-item">
                                          <i class="fa fa-arrow-circle-down"></i> کپی به عنوان Before
                                        </a>

                                        <a style="cursor: pointer;" *ngIf="item.before==true"
                                          (click)="Delete_Before(Nominal_Value_List_01.indexOf(item),2)"
                                          class="dropdown-item">
                                          <i class="fa fa-remove"></i> حذف Before
                                        </a>

                                      </div>
                                    </div>
                                  </div>

                                </td>
                              </tr>
                            </ng-container>
                          </tbody>

                        </table>

                      </td>
                    </tr>

                  </ng-container>

                </table>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>

    <div>

      <br />
      <hr />
      <br />
      <button *ngIf="InProccessing" type="button" class="btn btn-info" style="margin-left: 5px;"> سیستم در حال ساخت
        گواهی نامه می باشد. لطفا صبر نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>

      <button *ngIf="!InProccessing && !CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-success" style="margin-left: 5px;"><i
          class="fa  fa-plus-circle"></i> ثبت اطلاعات گواهی نامه </button>
      <button *ngIf="!InProccessing && CertificateCode" type="button"
        (click)="onSubmit(templateCode,templateCodeSerialDevice,0)" class="btn btn-info" style="margin-left: 5px;"><i
          class="fa  fa-edit"></i>
        ویرایش
        اطلاعات گواهی نامه </button>

      <a target="_blank" *ngIf="!InProccessing && CertificateCode && CertificateUrlPdf" href="{{CertificateUrlPdf}}"
        style="margin-left: 5px;" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> فایل گواهی نامه </a>

      <button routerLink="/KartableInbox" *ngIf="!InProccessing" type="button" style="margin-left: 5px;"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>

    </div>

  </div>
</div>

<ng-template #templateCode>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> کد گواهی نامه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Code.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <p>کد گواهی نامه فرم کالبیراسیون کد گواهی نامه <b>'{{CertificateCode}}'</b></p>
  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="modalRef_Code.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateCodeSerialDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> هشدار </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_CodeSerial.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <h6> {{modalRef_CodeSerial_Title}} </h6>

  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-success" (click)="onSubmit_Code(templateCode,templateCodeSerialDevice,1)">بله،
      مورد تایید است</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_CodeSerial.hide()">خیر</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/DataEntity/03_01/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/DataEntity/03_01/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateUnit>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> آیا واحد انتخاب شده  به واحد های تعیین  نشده، اعمال شود؟ </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Unit.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="SetToAllUnit()"> بله اعمال شود <i class="fa fa-check"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Unit.hide()">بستن</button>
  </div>
</ng-template>